// extracted by mini-css-extract-plugin
export var addressFields = "_mt-0";
export var animationContainer = "_mt-1";
export var footer = "_mt-2";
export var lineItems = "_mt-3";
export var modalContent = "_mt-4";
export var orderName = "_mt-5";
export var strong = "_mt-6";
export var warning = "_mt-7";